"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValid = exports["default"] = void 0;
exports.useValidatedRequest = useValidatedRequest;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _reactNumberFormat = require("react-number-format");
var _validators = require("../validators");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ValidatedInput(config) {
  var type = config.type,
    id = config.id,
    name = config.name,
    label = config.label,
    _config$value = config.value,
    value = _config$value === void 0 ? '' : _config$value,
    disabled = config.disabled,
    _config$size = config.size,
    size = _config$size === void 0 ? 'small' : _config$size,
    _config$variant = config.variant,
    variant = _config$variant === void 0 ? 'outlined' : _config$variant,
    startAdornment = config.startAdornment,
    endAdornment = config.endAdornment;
  var maxLength = config.maxLength,
    required = config.required,
    validators = config.validators;
  var rows = config.rows,
    maxRows = config.maxRows;
  var options = config.options;
  var format = config.format,
    mask = config.mask,
    autocomplete = config.autocomplete,
    onValueChanged = config.onValueChanged;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    blured = _useState2[0],
    setBlured = _useState2[1];
  var _useState3 = (0, _react.useState)({
      name: name,
      value: value,
      valid: true,
      blured: false,
      blurer: setBlured,
      reset: function reset() {
        setValidation(function (v) {
          return Object.assign(Object.assign({}, v), {
            value: '',
            valid: true,
            blured: false
          });
        });
      }
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    validation = _useState4[0],
    setValidation = _useState4[1];
  var validate = (0, _react.useCallback)(function (targetValue) {
    var allValidators = [];
    if (required) {
      allValidators.push(_validators.TEXT_REQUIRED_VALIDATOR);
    }
    if (validators) {
      allValidators = [].concat(_toConsumableArray(allValidators), _toConsumableArray(validators));
    }
    switch (type) {
      case 'email':
        allValidators.push(_validators.EMAIL_VALIDATOR);
        break;
      case 'tel':
        allValidators.push(_validators.PHONE_VALIDATOR);
        break;
      case 'password':
        allValidators.push(_validators.PASSWORD_VALIDATOR);
        break;
      case 'number':
        allValidators.push(_validators.NUMBER_VALIDATOR);
        break;
      case 'url':
        allValidators.push(_validators.URL_VALIDATOR);
        break;
    }
    var valid = true;
    var error;
    var _iterator = _createForOfIteratorHelper(allValidators),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var validator = _step.value;
        if (!validator.isValid(targetValue)) {
          valid = false;
          error = validator.getMessage();
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setValidation(function (cur) {
      return Object.assign(Object.assign({}, cur), {
        value: targetValue,
        valid: valid,
        error: error
      });
    });
  }, [type, validators, required]);
  var inputChanged = function inputChanged(event) {
    validate(event.target.value);
  };
  var selectChanged = function selectChanged(event, _child) {
    var value = event.target.value.toString();
    validate(value);
  };
  var inputBlured = function inputBlured(_event) {
    if (!blured) {
      setBlured(true);
    }
  };
  var buildOptions = (0, _react.useCallback)(function () {
    if (!options) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    }
    var regular = options;
    if (!!regular && !!regular.values) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, regular.values.map(function (value, index) {
        var _a;
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: value,
          value: value
        }, regular.labels ? (_a = regular.labels[index]) !== null && _a !== void 0 ? _a : value : value);
      }));
    }
    var grouped = options;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, grouped.map(function (group, i) {
      return /*#__PURE__*/_react["default"].createElement("optgroup", {
        key: group.group,
        label: group.group
      }, group.values.map(function (value, index) {
        var _a;
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: value,
          value: value
        }, group.labels ? (_a = group.labels[index]) !== null && _a !== void 0 ? _a : value : value);
      }));
    }));
  }, [options]);
  (0, _react.useEffect)(function () {
    // se solicita una validación inicialmente
    validate(value);
  }, [value, validate]);
  (0, _react.useEffect)(function () {
    // se reporta cada cambio en la referencia
    onValueChanged(validation.name, validation.value, validation);
    // eslint-disable-next-line
  }, [validation]);
  var commonProperties = function commonProperties() {
    var _a;
    return {
      key: id,
      id: id,
      name: name,
      label: label,
      required: required,
      value: validation.value ? validation.value : '',
      fullWidth: true,
      error: blured && !validation.valid,
      helperText: blured ? validation.error : undefined,
      inputProps: {
        maxLength: maxLength
      },
      onBlur: inputBlured,
      multiline: rows !== undefined,
      maxRows: (_a = maxRows !== null && maxRows !== void 0 ? maxRows : rows) !== null && _a !== void 0 ? _a : 1,
      disabled: disabled,
      InputProps: {
        startAdornment: startAdornment,
        endAdornment: endAdornment
      }
    };
  };
  var onMaskedInputChanged = function onMaskedInputChanged(values) {
    if (!values) return;
    var fixed = values['value'] || values['floatValue'] || values['formattedValue'];
    validate(fixed);
  };
  if (options) {
    return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
      margin: "dense",
      size: size,
      variant: variant,
      fullWidth: true,
      required: required,
      error: blured && !validation.valid
    }, /*#__PURE__*/_react["default"].createElement(_material.InputLabel, {
      htmlFor: id
    }, label), /*#__PURE__*/_react["default"].createElement(_material.Select, {
      "native": true,
      value: validation.value ? validation.value : '',
      label: label,
      disabled: disabled,
      onChange: selectChanged,
      inputProps: {
        name: name,
        id: id
      },
      required: required
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: ""
    }), buildOptions()), blured && /*#__PURE__*/_react["default"].createElement(_material.FormHelperText, null, validation.error));
  }
  if (format) {
    return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.PatternFormat, Object.assign({
      customInput: _material.TextField,
      size: size,
      margin: "dense",
      format: format,
      mask: mask || '_',
      onValueChange: onMaskedInputChanged
    }, commonProperties()));
  }
  return /*#__PURE__*/_react["default"].createElement(_material.TextField, Object.assign({
    type: type,
    variant: variant,
    size: size,
    margin: "dense",
    autoComplete: autocomplete,
    onChange: inputChanged
  }, commonProperties()));
}
var isValid = exports.isValid = function isValid(validations, avoidBlur) {
  var valid = true;
  for (var field in validations) {
    var ref = validations[field];
    if (!ref.valid) {
      if (!avoidBlur) {
        ref.blurer(true);
      }
      valid = false;
    }
  }
  return valid;
};
function useValidatedRequest(initial, transformer) {
  var _useState5 = (0, _react.useState)(initial !== null && initial !== void 0 ? initial : {}),
    _useState6 = _slicedToArray(_useState5, 2),
    request = _useState6[0],
    setRequest = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    validations = _useState8[0],
    setValidations = _useState8[1];
  var hasChangedAny = (0, _react.useCallback)(function (name, value, inputRef) {
    setRequest(function (request) {
      return Object.assign(Object.assign({}, request), _defineProperty({}, name, value));
    });
    setValidations(function (validations) {
      validations[inputRef.name] = inputRef;
      return validations;
    });
  }, [setRequest, setValidations]);
  var hasChanged = (0, _react.useCallback)(function (name, value, inputRef) {
    var fixedValue = transformer ? transformer(name, value) : value;
    hasChangedAny(name, fixedValue, inputRef);
  }, [hasChangedAny, transformer]);
  var updateRequest = (0, _react.useCallback)(function (request) {
    setRequest(request);
  }, [setRequest]);
  var clear = function clear() {
    setRequest({});
    for (var field in validations) {
      var ref = validations[field];
      ref.reset();
    }
  };
  return [request, updateRequest, validations, hasChanged, clear, hasChangedAny];
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ValidatedInput);